import { addCategories } from "_services";
import { uploadFile } from "_services/userService";
import { CommonInput, CommonModal } from "components";
import { Images } from "constants";
import { errorSchema, utils } from "helper";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { FaPencil } from "react-icons/fa6";

const AddCatergoryModal = (props) => {
  const [formValue, setFormValue] = useState({
    title: "",
    imageUrl: "",
  });

  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);

  const handleOnChange = (name, value) => {
    setFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClick = async (e) => {
    e.preventDefault();

    const validationResult = await utils?.checkFormError(
      formValue,
      errorSchema.addCategorySchema
    );

    if (utils?.isObjectKeyEmpty(validationResult)) {
      setLoading(true);
      try {
        await addCategories(formValue);
        toast.success("Category added successfully!");
        props?.closeModal(); // Close modal
        if (props?.onSuccess) props.onSuccess();
        setFormValue({ title: "", imageUrl: "" });
        setFormError({});
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    } else {
      setFormError(validationResult);
    }
  };

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;
      const response = await uploadFile(file);
      if (response?.data?.file?.fullUrl) {
        setFormValue((prev) => ({
          ...prev,
          imageUrl: response?.data?.file?.fullUrl,
        }));
      }
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  const propsAddCategory = {
    ...props,
    onSubmit: handleClick,
    submitLoading: loading,
  };

  return (
    <>
      <CommonModal {...propsAddCategory}>
        <div className="addLr_body">
          <div className="_allDflx">
            <div>
              <CommonInput
                type="text"
                placeholder="Category Name"
                label="Category Name *"
                name="title"
                value={formValue.title}
                focus={!!formError.title}
                error={formError.title}
                onChange={({ target: { name, value } }) =>
                  handleOnChange(name, value)
                }
              />
            </div>

            <div>
              <div style={{marginBottom:'5px', padding:'0 3px'}}>Add Image</div>
              <div className="__profilPic_bx " style={{margin: '0px', borderRadius:'8px'}}>
                <img
                style={{ borderRadius:'8px'}}
                  src={formValue?.imageUrl || Images.UPLOADIMG}
                  alt="User Profile"
                  className=""
                />
                <button
                  type="button"
                  className="__profilPic_edit "
                  onClick={() => document.getElementById("fileInput").click()}
                >
                  <FaPencil />
                </button>
                <input
                  style={{ display: "none" }}
                  type="file"
                  id="fileInput"
                  accept="image/*"
                  className="hidden"
                  onChange={handleFileUpload}
                />
              </div>
            </div>

            <div>
              <CommonInput
                type="text"
                placeholder="Image URL"
                label="Image URL *"
                name="imageUrl"
                value={formValue.imageUrl}
                // focus={!!formError.imageUrl}
                // error={formError.imageUrl}
                onChange={({ target: { name, value } }) =>
                  handleOnChange(name, value)
                }
                disabled={true}
              />
            </div>
          </div>
        </div>
      </CommonModal>
    </>
  );
};

export default AddCatergoryModal;
